import { isStandardHigh, isStandardLow } from "../Cabin/cabinConditions";

import { WrapMdMarginBottom } from "App/global-style";
import { ContactUsAlert } from "Components/Form/Alert";
import { RadioButton } from "Components/Form/RadioButton";
import { useButtonTexts } from "Store/texts/hooks";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { getOptions } from "../houseProductsUtils";

interface HousingStandard {
  standard: string;
}

interface Props<T extends HousingStandard = HousingStandard> {
  formProps: FormikProps<T>;
  aboutProductText: any;
  lang: string;
}

export const ChooseStandard = ({
  formProps,
  aboutProductText,
  lang,
}: Props): React.ReactElement => {
  const [hintTexts] = useButtonTexts();
  return (
    <>
      <RadioButton
        name="standard"
        id="standard"
        label={aboutProductText.standard.label[lang]}
        hint={aboutProductText.standard.hint[lang]}
        options={getOptions(aboutProductText.standard, hintTexts, lang)}
        direction="vertical"
        error={getError("standard", formProps)}
      />
      {(isStandardHigh(formProps.values.standard) ||
        isStandardLow(formProps.values.standard)) && (
        <WrapMdMarginBottom>
          <ContactUsAlert
            description={
              isStandardHigh(formProps.values.standard)
                ? aboutProductText.standard.higher[lang]
                : aboutProductText.standard.lower[lang]
            }
            title={aboutProductText.standard.alertTitle[lang]}
            alertId="standard"
          />
        </WrapMdMarginBottom>
      )}
    </>
  );
};
